import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-input-group-example',
  templateUrl: './input-group.component.html',
})
export class KitBootstrapInputGroupExampleComponent {}
